import type { FieldError } from 'react-hook-form';
import type { ReactNode } from 'react';

interface FormFieldProps {
  label: string;
  required?: boolean;
  error?: FieldError;
  children: ReactNode;
}

export function FormField({ label, required, error, children }: FormFieldProps) {
  return (
    <div className="form-group">
      <label>
        {label}
        {required && <span className="required-mark"> *</span>}
      </label>
      {children}
      {error && <span className="error-text">{error.message}</span>}
    </div>
  );
}
